import React from "react";
import { type PersistentNotification, PersistentNotificationImpactSeverity } from "../../api";
import { observer } from "mobx-react";
import { action, makeObservable } from "mobx";
import { store } from "../../store";
import { routePath } from "../../route-path";
import {
    NotificationCard,
    NotificationLink,
    NotificationRow,
    NotificationTitle,
} from "./notification-item";

export type ImpactNotificationItemProps = {
    notification: PersistentNotification;
    markNotificationRead?: (id: string) => void;
};

@observer
export class ImpactNotificationItem extends React.Component<ImpactNotificationItemProps> {
    constructor(props: ImpactNotificationItemProps) {
        super(props);
        makeObservable(this);
    }

    @action.bound private markRead(): void {
        if (this.props.markNotificationRead) {
            this.props.markNotificationRead(this.props.notification.id);
        }
    }

    render(): JSX.Element {
        const notification = this.props.notification;

        const vehicle = store.repositoryVehicles.byId(notification.vehicleId);
        if (!vehicle) {
            return <></>;
        }

        let fleetUserName = store.i18n.t("component.notificationItemImpact.noOperator");
        if (notification.fleetUserId) {
            const fleetUser = store.repositoryUsers.byId(notification.fleetUserId);
            if (fleetUser) {
                fleetUserName = `${fleetUser.firstName} ${fleetUser.lastName}`;
            }
        }

        let title;
        switch (notification.impactSeverity) {
            case PersistentNotificationImpactSeverity.SEVERE:
                title = store.i18n.t("component.notificationItemImpact.severe");
                break;
            case PersistentNotificationImpactSeverity.MEDIUM:
                title = store.i18n.t("component.notificationItemImpact.medium");
                break;
        }

        return (
            <NotificationCard markRead={!this.props.notification.read ? this.markRead : undefined}>
                <NotificationTitle to={routePath.impactManagement()}>{title}</NotificationTitle>
                <NotificationRow>
                    {store.i18n.formatDateTime(notification.triggeredAt)}
                </NotificationRow>
                <NotificationRow>
                    <span>{store.i18n.t("component.notificationItemImpact.truck")}:</span>
                    <NotificationLink to={routePath.vehicles()}>
                        {vehicle.serialNumber}
                    </NotificationLink>
                </NotificationRow>
                <NotificationRow>
                    <span>{store.i18n.t("component.notificationItemImpact.operator")}:</span>
                    <NotificationLink to={routePath.users()}>{fleetUserName}</NotificationLink>
                </NotificationRow>
            </NotificationCard>
        );
    }
}
